import Swiper from "swiper";
import {
	Autoplay,
	Navigation,
	EffectFade,
	Keyboard,
	Thumbs,
	FreeMode,
} from "swiper/modules";
import imagesLoaded from "imagesloaded";
import "uikit/dist/js/uikit.min.js";

// Enable Tooltips everywhere
import Tooltip from "bootstrap/js/dist/tooltip";
var tooltipTriggerList = [].slice.call(
	document.querySelectorAll('[data-bs-toggle="tooltip"]'),
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl);
});

//
// Gravity Forms date field helpers.
//
// Gravity Forms 3.0 replaced the jQuery UI datepicker with an accessible
// vanilla JS picker, so `jQuery( input ).datepicker( ... )` no longer exists.
// The new picker re-reads its input every time it renders, which means a
// correctly formatted value plus native events is all the syncing it needs.
//
const gravityDateFormats = {
	ymd_dash: "YYYY-MM-DD",
	ymd_dot: "YYYY.MM.DD",
	ymd_slash: "YYYY/MM/DD",
	dmy_dash: "DD-MM-YYYY",
	dmy_dot: "DD.MM.YYYY",
	dmy: "DD/MM/YYYY",
	mdy: "MM/DD/YYYY",
};

// Today at local midnight. The date comes from the server (see the
// `ajax_object` localisation in functions.php) so it matches the availability
// calendar's own idea of today, which is rendered in the site's timezone.
const getToday = () => {
	const serverToday =
		typeof ajax_object !== "undefined" && ajax_object && ajax_object.today
			? String(ajax_object.today).split("-").map(Number)
			: null;

	if (
		serverToday &&
		serverToday.length === 3 &&
		!serverToday.some(Number.isNaN)
	) {
		return new Date(serverToday[0], serverToday[1] - 1, serverToday[2]);
	}

	const now = new Date();
	return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

const gfDate = {
	// Gravity Forms puts the field's date format on the input as a CSS class.
	getFormat(inputEl) {
		if (inputEl && inputEl.classList) {
			for (const formatClass of Object.keys(gravityDateFormats)) {
				if (inputEl.classList.contains(formatClass)) {
					return gravityDateFormats[formatClass];
				}
			}
		}

		return "MM/DD/YYYY";
	},

	format(inputEl, dateObj) {
		if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) {
			return "";
		}

		return gfDate
			.getFormat(inputEl)
			.replace("YYYY", String(dateObj.getFullYear()))
			.replace("MM", String(dateObj.getMonth() + 1).padStart(2, "0"))
			.replace("DD", String(dateObj.getDate()).padStart(2, "0"));
	},

	parse(inputEl) {
		if (!inputEl || !inputEl.value) return null;

		const tokens = gfDate.getFormat(inputEl).split(/[^A-Z]+/);
		const parts = inputEl.value.trim().split(/\D+/);
		if (tokens.length !== 3 || parts.length !== 3) return null;

		const values = {};
		tokens.forEach((token, index) => {
			values[token] = parseInt(parts[index], 10);
		});

		const year = values.YYYY;
		const month = values.MM;
		const day = values.DD;
		if (!year || !month || !day) return null;

		const dateObj = new Date(year, month - 1, day);
		const isRealDate =
			dateObj.getFullYear() === year &&
			dateObj.getMonth() === month - 1 &&
			dateObj.getDate() === day;

		return isRealDate ? dateObj : null;
	},

	getToggle(inputEl) {
		if (!inputEl || !inputEl.id) return null;

		return (
			document.getElementById(`datepicker_toggle_${inputEl.id}`) ||
			(inputEl.parentElement &&
				inputEl.parentElement.querySelector("button.gform-datepicker-toggle"))
		);
	},

	// Pass a null date to clear the field.
	setValue(inputEl, dateObj) {
		if (!inputEl) return;

		inputEl.value = dateObj ? gfDate.format(inputEl, dateObj) : "";
		inputEl.dispatchEvent(new Event("input", { bubbles: true }));
		inputEl.dispatchEvent(new Event("change", { bubbles: true }));
	},

	setDisabled(inputEl, disabled) {
		if (!inputEl) return;

		inputEl.disabled = !!disabled;

		const toggle = gfDate.getToggle(inputEl);
		if (toggle) {
			toggle.disabled = !!disabled;
		}
	},
};

document.addEventListener("DOMContentLoaded", () => {
	// Fixing smooth scroll offset for anchor links
	const offset = 220;

	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		// Skip pagination links - they have their own click handlers
		// if (anchor.closest(".pagination")) {
		// 	return;
		// }

		anchor.addEventListener("click", function (e) {
			const targetId = this.getAttribute("href");
			const targetElement = document.querySelector(targetId);

			if (targetElement) {
				e.preventDefault();

				const elementPosition =
					targetElement.getBoundingClientRect().top + window.pageYOffset;
				const offsetPosition = elementPosition - offset;

				window.scrollTo({
					top: offsetPosition,
					behavior: "smooth",
				});
			}
		});
	});

	// Menu Scrolling
	const navbar = document.getElementById("wrapper-navbar");
	let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

	// Check scroll position on load
	if ((window.pageYOffset || document.documentElement.scrollTop) > 100) {
		navbar.classList.add("scrolled");
	} else {
		navbar.classList.remove("scrolled");
	}

	window.addEventListener("scroll", function () {
		const currentScroll =
			window.pageYOffset || document.documentElement.scrollTop;

		if (currentScroll > 100) {
			navbar.classList.add("scrolled");
		} else {
			navbar.classList.remove("scrolled");
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Safari
	});

	//
	// Villa Calendars
	//
	const calContainer = document.getElementById("villaCalendars");
	if (calContainer) {
		const ical = calContainer.dataset.ical;
		const calendarWrapper = document.getElementById("villaCalendarsWrapper");
		const monthSelect = document.getElementById("calendarMonthSelect");
		let selectedCheckIn = null;
		let selectedCheckOut = null;
		const MIN_STAY_DAYS_AFTER_CHECK_IN = 2;
		const MIN_STAY_NIGHTS = 3;
		let inquiryEscapeHandler = null;
		let inquiryFocusState = null;

		const parseIsoDate = (isoDate) => {
			if (!isoDate) return null;
			const [year, month, day] = isoDate.split("-").map(Number);
			if (!year || !month || !day) return null;
			return new Date(year, month - 1, day);
		};

		const toIsoDate = (dateObj) => {
			if (!(dateObj instanceof Date)) return "";
			const year = dateObj.getFullYear();
			const month = String(dateObj.getMonth() + 1).padStart(2, "0");
			const day = String(dateObj.getDate()).padStart(2, "0");
			return `${year}-${month}-${day}`;
		};

		const toFriendlyDate = (isoDate) => {
			const dateObj = parseIsoDate(isoDate);
			if (!dateObj) return "";
			return dateObj.toLocaleDateString(undefined, {
				weekday: "short",
				month: "short",
				day: "numeric",
				year: "numeric",
			});
		};

		const findInquiryDateInputs = () => {
			const inquiryForm = document.querySelector(".inquiry-form");
			const checkInEl =
				(inquiryForm && inquiryForm.querySelector("#input_1_6, #input_2_6")) ||
				document.querySelector("#input_1_6, #input_2_6");
			const checkOutEl =
				(inquiryForm && inquiryForm.querySelector("#input_1_7, #input_2_7")) ||
				document.querySelector("#input_1_7, #input_2_7");

			return { inquiryForm, checkInEl, checkOutEl };
		};

		const setGravityDateValue = (inputEl, isoDate) => {
			const parsedDate = parseIsoDate(isoDate);
			if (!parsedDate) return;

			gfDate.setValue(inputEl, parsedDate);
		};

		const closeInquiryFocus = (immediate = false) => {
			const overlay = document.getElementById("villaInquiryFocusOverlay");
			const inquiryTarget = document.querySelector(
				".inquiry-form.villa-inquiry-focus-target",
			);
			const animationDuration = 260;

			const restoreInquiryForm = () => {
				if (inquiryFocusState && inquiryFocusState.inquiryForm) {
					const {
						inquiryForm,
						placeholder,
						originalParent,
						originalNextSibling,
						layer,
					} = inquiryFocusState;

					inquiryForm.classList.remove(
						"villa-inquiry-focus-target",
						"villa-inquiry-floating",
						"is-active",
					);

					if (originalParent && originalParent.isConnected) {
						if (
							originalNextSibling &&
							originalNextSibling.parentNode === originalParent
						) {
							originalParent.insertBefore(inquiryForm, originalNextSibling);
						} else if (
							placeholder &&
							placeholder.parentNode === originalParent
						) {
							originalParent.insertBefore(inquiryForm, placeholder);
						} else {
							originalParent.appendChild(inquiryForm);
						}
					}

					if (placeholder && placeholder.parentNode) {
						placeholder.remove();
					}

					if (layer && layer.parentNode) {
						layer.remove();
					}
				}

				inquiryFocusState = null;
			};

			if (overlay) {
				overlay.classList.remove("is-active");
				if (immediate) {
					overlay.remove();
				} else {
					setTimeout(() => {
						overlay.remove();
					}, animationDuration);
				}
			}

			if (inquiryTarget) {
				inquiryTarget.classList.remove("is-active");
			}

			document.body.classList.remove("villa-inquiry-focus-active");
			if (immediate) {
				restoreInquiryForm();
			} else {
				setTimeout(restoreInquiryForm, animationDuration);
			}

			if (inquiryEscapeHandler) {
				document.removeEventListener("keydown", inquiryEscapeHandler);
				inquiryEscapeHandler = null;
			}
		};

		const focusInquiryForm = () => {
			const { inquiryForm } = findInquiryDateInputs();
			if (!inquiryForm) return;

			closeInquiryFocus(true);

			const originalParent = inquiryForm.parentNode;
			if (!originalParent) return;

			const originalNextSibling = inquiryForm.nextSibling;
			const placeholder = document.createElement("div");
			placeholder.className = "villa-inquiry-focus-placeholder";
			placeholder.style.display = "none";
			originalParent.insertBefore(placeholder, inquiryForm);

			const overlay = document.createElement("div");
			overlay.id = "villaInquiryFocusOverlay";
			document.body.appendChild(overlay);

			const layer = document.createElement("div");
			layer.id = "villaInquiryFocusLayer";
			document.body.appendChild(layer);

			inquiryFocusState = {
				inquiryForm,
				placeholder,
				originalParent,
				originalNextSibling,
				layer,
			};

			requestAnimationFrame(() => {
				overlay.classList.add("is-active");
			});

			overlay.addEventListener("click", closeInquiryFocus);

			inquiryEscapeHandler = (event) => {
				if (event.key === "Escape") {
					closeInquiryFocus();
				}
			};
			document.addEventListener("keydown", inquiryEscapeHandler);

			document.body.classList.add("villa-inquiry-focus-active");
			inquiryForm.classList.add(
				"villa-inquiry-focus-target",
				"villa-inquiry-floating",
			);
			layer.appendChild(inquiryForm);

			requestAnimationFrame(() => {
				inquiryForm.classList.add("is-active");
			});

			setTimeout(() => {
				const firstFocusable = inquiryForm.querySelector(
					"input, select, textarea, button",
				);
				if (firstFocusable) {
					firstFocusable.focus({ preventScroll: true });
				}
			}, 280);
		};

		const getAllDateCells = () => {
			return Array.from(
				calendarWrapper.querySelectorAll(".calendar-grid .col[data-date]"),
			).filter((cell) => cell.dataset.date);
		};

		// Dates before today are rendered with `date-past` (see
		// functions/calendars.php) and can never be part of a stay.
		const isPastCell = (cell) => {
			const cellDateObj = parseIsoDate(cell.dataset.date);
			return cellDateObj ? cellDateObj < getToday() : false;
		};

		const isCheckInSelectable = (cell) => {
			if (isPastCell(cell)) return false;

			return (
				cell.classList.contains("date-avail") ||
				(cell.classList.contains("date-booked") &&
					cell.classList.contains("date-check-out"))
			);
		};

		const isCheckOutSelectable = (cell) => {
			if (isPastCell(cell)) return false;

			return (
				cell.classList.contains("date-avail") ||
				(cell.classList.contains("date-booked") &&
					cell.classList.contains("date-check-in"))
			);
		};

		const isStayNightAvailable = (cell) => {
			return cell.classList.contains("date-avail");
		};

		const getDateCellByIso = (isoDate) => {
			return calendarWrapper.querySelector(
				`.calendar-grid .col[data-date="${isoDate}"]`,
			);
		};

		const clearInquiryDates = () => {
			const { checkInEl, checkOutEl } = findInquiryDateInputs();

			[checkInEl, checkOutEl].forEach((inputEl) => {
				gfDate.setValue(inputEl, null);
			});
		};

		const removeDateSelectionClasses = () => {
			calendarWrapper
				.querySelectorAll(
					".date-selected-start, .date-selected-end, .date-selected-range",
				)
				.forEach((cell) => {
					cell.classList.remove(
						"date-selected-start",
						"date-selected-end",
						"date-selected-range",
					);
				});
		};

		const setSelectionUi = (
			helperTextEl,
			selectionTextEl,
			actionBtnEl,
			clearBtnEl,
		) => {
			removeDateSelectionClasses();

			if (!selectedCheckIn) {
				helperTextEl.textContent = "Select a check-in date to begin.";
				selectionTextEl.hidden = true;
				selectionTextEl.textContent = "";
				actionBtnEl.hidden = true;
				clearBtnEl.hidden = true;
				return;
			}

			const cells = getAllDateCells();
			const startDateObj = parseIsoDate(selectedCheckIn);
			const endDateObj = parseIsoDate(selectedCheckOut);

			cells.forEach((cell) => {
				const cellDateObj = parseIsoDate(cell.dataset.date);
				if (!cellDateObj || !startDateObj) return;

				if (cell.dataset.date === selectedCheckIn) {
					cell.classList.add("date-selected-start");
				}

				if (selectedCheckOut && cell.dataset.date === selectedCheckOut) {
					cell.classList.add("date-selected-end");
				}

				if (
					selectedCheckOut &&
					cellDateObj > startDateObj &&
					cellDateObj < endDateObj
				) {
					cell.classList.add("date-selected-range");
				}
			});

			if (!selectedCheckOut) {
				helperTextEl.textContent = `Now choose a check-out date for a minimum ${MIN_STAY_NIGHTS} night stay.`;
				selectionTextEl.hidden = false;
				selectionTextEl.textContent = `Check-in selected: ${toFriendlyDate(selectedCheckIn)}`;
				actionBtnEl.hidden = true;
				clearBtnEl.hidden = false;
				return;
			}

			helperTextEl.textContent =
				"Dates selected. Continue to the inquiry form to request these exact dates.";
			selectionTextEl.hidden = false;
			selectionTextEl.textContent = `Selected stay: ${toFriendlyDate(selectedCheckIn)} to ${toFriendlyDate(selectedCheckOut)}`;
			actionBtnEl.hidden = false;
			clearBtnEl.hidden = false;
		};

		const rangeIsAvailable = (startIso, endIso) => {
			const startDate = parseIsoDate(startIso);
			const endDate = parseIsoDate(endIso);
			if (!startDate || !endDate || endDate <= startDate) return false;

			const minCheckOutDate = new Date(startDate);
			minCheckOutDate.setDate(
				minCheckOutDate.getDate() + MIN_STAY_DAYS_AFTER_CHECK_IN,
			);
			if (endDate < minCheckOutDate) return false;

			const startCell = getDateCellByIso(startIso);
			const endCell = getDateCellByIso(endIso);
			if (!startCell || !endCell) return false;

			if (!isCheckInSelectable(startCell) || !isCheckOutSelectable(endCell)) {
				return false;
			}

			const cursor = new Date(startDate);
			cursor.setDate(cursor.getDate() + 1);
			while (cursor < endDate) {
				const middleCell = getDateCellByIso(toIsoDate(cursor));
				if (!middleCell || !isStayNightAvailable(middleCell)) return false;
				cursor.setDate(cursor.getDate() + 1);
			}

			return true;
		};

		const prefillInquiryDates = () => {
			const { checkInEl, checkOutEl } = findInquiryDateInputs();
			if (!checkInEl || !checkOutEl || !selectedCheckIn || !selectedCheckOut) {
				return;
			}

			setGravityDateValue(checkInEl, selectedCheckIn);
			setGravityDateValue(checkOutEl, selectedCheckOut);
		};

		const enhanceCalendarInteractivity = () => {
			if (!calendarWrapper) return;

			calendarWrapper.querySelectorAll(".card").forEach((card) => {
				const monthValue = card.dataset.month;
				if (!monthValue) return;

				card
					.querySelectorAll(
						".calendar-grid .col.date-avail, .calendar-grid .col.date-booked",
					)
					.forEach((cell) => {
						const dayNum = parseInt(cell.textContent.trim(), 10);
						if (!dayNum || Number.isNaN(dayNum)) return;

						const isoDate = `${monthValue}-${String(dayNum).padStart(2, "0")}`;
						cell.dataset.date = isoDate;

						const canSelect =
							isCheckInSelectable(cell) || isCheckOutSelectable(cell);
						if (canSelect) {
							cell.setAttribute("role", "button");
							cell.setAttribute("tabindex", "0");
							cell.setAttribute(
								"aria-label",
								`Select ${new Date(`${isoDate}T00:00:00`).toLocaleDateString()}`,
							);
						} else {
							cell.removeAttribute("role");
							cell.setAttribute("tabindex", "-1");
							cell.removeAttribute("aria-label");
						}
					});
			});

			let controls = calContainer.querySelector(".js-villa-calendar-controls");
			if (!controls) {
				controls = document.createElement("div");
				controls.className =
					"js-villa-calendar-controls shadow-sm rounded-4 bg-light text-center mt-3 mb-2 py-4 d-flex flex-column align-items-center";

				const helperText = document.createElement("p");
				helperText.className =
					"villa-inquiry-dates-helper text-muted mb-0 js-villa-calendar-helper";
				controls.appendChild(helperText);

				const selectionText = document.createElement("p");
				selectionText.className =
					"villa-inquiry-dates-helper text-dark fw-semibold mb-0 mt-3 js-villa-calendar-selection";
				selectionText.hidden = true;
				controls.appendChild(selectionText);

				const actionBtn = document.createElement("button");
				actionBtn.type = "button";
				actionBtn.className =
					"btn btn-primary text-white rounded-pill mt-3 px-4 js-villa-calendar-cta";
				actionBtn.textContent = "Inquire about these dates";
				actionBtn.hidden = true;
				actionBtn.addEventListener("click", () => {
					prefillInquiryDates();
					focusInquiryForm();
				});
				controls.appendChild(actionBtn);

				const clearBtn = document.createElement("button");
				clearBtn.type = "button";
				clearBtn.className =
					"btn btn-link text-decoration-none mt-2 js-villa-calendar-clear";
				clearBtn.textContent = "Clear selected dates";
				clearBtn.hidden = true;
				clearBtn.addEventListener("click", () => {
					selectedCheckIn = null;
					selectedCheckOut = null;
					clearInquiryDates();
					setSelectionUi(helperText, selectionText, actionBtn, clearBtn);
				});
				controls.appendChild(clearBtn);

				calContainer.appendChild(controls);
			}

			const helperTextEl = controls.querySelector(".js-villa-calendar-helper");
			const selectionTextEl = controls.querySelector(
				".js-villa-calendar-selection",
			);
			const actionBtnEl = controls.querySelector(".js-villa-calendar-cta");
			const clearBtnEl = controls.querySelector(".js-villa-calendar-clear");
			if (!helperTextEl || !selectionTextEl || !actionBtnEl || !clearBtnEl)
				return;

			setSelectionUi(helperTextEl, selectionTextEl, actionBtnEl, clearBtnEl);

			const dateCells = getAllDateCells();
			dateCells.forEach((cell) => {
				const handleSelection = () => {
					const selectedDate = cell.dataset.date;
					if (!selectedDate) return;

					if (!selectedCheckIn || (selectedCheckIn && selectedCheckOut)) {
						if (!isCheckInSelectable(cell)) {
							helperTextEl.textContent = isPastCell(cell)
								? "Check-in cannot be a date in the past."
								: "Please choose an available date or a valid check-out turnover day for check-in.";
							actionBtnEl.hidden = true;
							return;
						}

						selectedCheckIn = selectedDate;
						selectedCheckOut = null;
						setSelectionUi(
							helperTextEl,
							selectionTextEl,
							actionBtnEl,
							clearBtnEl,
						);
						return;
					}

					const startDate = parseIsoDate(selectedCheckIn);
					const candidateDate = parseIsoDate(selectedDate);
					if (!startDate || !candidateDate) return;

					if (candidateDate <= startDate) {
						if (!isCheckInSelectable(cell)) {
							helperTextEl.textContent = isPastCell(cell)
								? "Check-in cannot be a date in the past."
								: "Please choose an available date or a valid check-out turnover day for check-in.";
							actionBtnEl.hidden = true;
							return;
						}

						selectedCheckIn = selectedDate;
						selectedCheckOut = null;
						setSelectionUi(
							helperTextEl,
							selectionTextEl,
							actionBtnEl,
							clearBtnEl,
						);
						return;
					}

					const minCheckOutDate = new Date(startDate);
					minCheckOutDate.setDate(
						minCheckOutDate.getDate() + MIN_STAY_DAYS_AFTER_CHECK_IN,
					);
					if (candidateDate < minCheckOutDate) {
						helperTextEl.textContent = `Please choose dates for at least ${MIN_STAY_NIGHTS} nights.`;
						actionBtnEl.hidden = true;
						return;
					}

					if (!isCheckOutSelectable(cell)) {
						helperTextEl.textContent =
							"Please choose an available date or a valid check-in turnover day for check-out.";
						actionBtnEl.hidden = true;
						return;
					}

					if (!rangeIsAvailable(selectedCheckIn, selectedDate)) {
						helperTextEl.textContent =
							"Those dates cross unavailable nights. Please choose a different check-out date.";
						actionBtnEl.hidden = true;
						return;
					}

					selectedCheckOut = selectedDate;
					prefillInquiryDates();
					setSelectionUi(
						helperTextEl,
						selectionTextEl,
						actionBtnEl,
						clearBtnEl,
					);
				};

				cell.addEventListener("click", handleSelection);
				cell.addEventListener("keydown", (event) => {
					if (event.key === "Enter" || event.key === " ") {
						event.preventDefault();
						handleSelection();
					}
				});
			});
		};

		// loader element (single)
		const loader = document.createElement("div");
		loader.className = "text-center py-5";
		loader.innerHTML = `
        <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div>Loading calendars...</div>
    `;

		const loadCalendars = (startMonth) => {
			selectedCheckIn = null;
			selectedCheckOut = null;
			closeInquiryFocus();
			calendarWrapper.innerHTML = "";
			calContainer.prepend(loader);
			calendarWrapper.classList.add("d-none");

			// Parse selected month
			const [yearNum, monthNum] = startMonth.split("-").map(Number);

			// Build 3 months starting from selected month
			const months = [];
			for (let i = 0; i < 3; i++) {
				let y = yearNum;
				let m = monthNum + i;
				if (m > 12) {
					y += 1;
					m -= 12;
				}
				months.push({
					value: `${y}-${String(m).padStart(2, "0")}`,
					display: new Date(y, m - 1, 1).toLocaleString("default", {
						month: "long",
						year: "numeric",
					}),
				});
			}

			// Create placeholders
			const placeholders = months.map(() => {
				const col = document.createElement("div");
				col.className = "col villa-calendar mb-5";
				calendarWrapper.appendChild(col);
				return col;
			});

			// Fetch all calendars in parallel
			const promises = months.map(({ value, display }, index) => {
				const formData = new FormData();
				formData.append("action", "get_calendar");
				formData.append("month", value);
				formData.append("ical", ical);

				return fetch("/wp-admin/admin-ajax.php", {
					method: "POST",
					body: formData,
				})
					.then((res) => res.json())
					.then((data) => {
						placeholders[index].innerHTML = `
                <div class="card h-100">
                    <div class="card-header text-center fw-bold fs-sm">${display}</div>
                    <div class="card-body p-2">${
											data.success
												? data.data
												: '<div class="text-danger text-center py-3">Error loading calendar</div>'
										}</div>
                </div>
            `;
					})
					.catch(() => {
						placeholders[index].innerHTML =
							'<div class="text-danger text-center py-5">Error loading calendar</div>';
					});
			});

			Promise.all(promises).finally(() => {
				calendarWrapper.querySelectorAll(".card").forEach((card, idx) => {
					if (months[idx]) {
						card.dataset.month = months[idx].value;
					}
				});
				enhanceCalendarInteractivity();
				loader.remove();
				calendarWrapper.classList.remove("d-none"); // show container once all calendars are loaded
			});
		};

		// Initial load
		calendarWrapper.classList.add("d-none"); // hide container before first load
		const initialMonth = monthSelect
			? monthSelect.value
			: new Date().toISOString().slice(0, 7);
		loadCalendars(initialMonth);

		// Dropdown change
		if (monthSelect) {
			monthSelect.addEventListener("change", (e) => {
				loader &&
					!calendarWrapper.contains(loader) &&
					calendarWrapper.prepend(loader); // hide container while loading new months
				loadCalendars(e.target.value);
			});
		}
	}

	// Inquiry Form – Setting Check-in and Check-out dates
	//
	// The check-out restriction used to be applied with the jQuery UI
	// datepicker's `minDate` option, which Gravity Forms 3.0 removed. It is now
	// applied through the datepicker options filter (read when a picker is first
	// built) and the picker's own `configure` callback (read again on every
	// later open), backed by a value check that drops an out-of-range date.
	//
	// The same filter turns on `openOnFocus` for every Gravity Forms datepicker,
	// so clicking or tabbing into a date input opens the calendar.
	const INQUIRY_FORM_IDS = [1, 2];
	const CHECK_IN_FIELD_ID = 6;
	const CHECK_OUT_FIELD_ID = 7;

	const getInquiryDateField = (formId, fieldId) =>
		document.getElementById(`input_${formId}_${fieldId}`);

	const getInquiryCheckInDate = (formId) =>
		gfDate.parse(getInquiryDateField(formId, CHECK_IN_FIELD_ID));

	const enforceCheckOutDate = (formId) => {
		const checkOutEl = getInquiryDateField(formId, CHECK_OUT_FIELD_ID);
		if (!checkOutEl) return;

		const checkInEl = getInquiryDateField(formId, CHECK_IN_FIELD_ID);
		let checkInDate = gfDate.parse(checkInEl);

		// A check-in date in the past is never valid, however it got there.
		if (checkInDate && checkInDate < getToday()) {
			gfDate.setValue(checkInEl, null);
			checkInDate = null;
		}

		// Check-out stays locked until there is a check-in date to compare to.
		gfDate.setDisabled(checkOutEl, !checkInDate);
		if (!checkInDate) return;

		const checkOutDate = gfDate.parse(checkOutEl);
		if (checkOutDate && checkOutDate < getCheckOutMinDate(formId)) {
			gfDate.setValue(checkOutEl, null);
		}
	};

	// Check-out can be no earlier than the check-in date, and neither field may
	// reach into the past.
	const getCheckOutMinDate = (formId) => {
		const today = getToday();
		const checkInDate = getInquiryCheckInDate(formId);

		return checkInDate && checkInDate > today ? checkInDate : today;
	};

	const applyCheckOutMinDate = (datepicker, formId) => {
		datepicker.minDate = getCheckOutMinDate(formId);
		datepicker.minDateComparisonValue = null;

		if (typeof datepicker.setDateComparisons === "function") {
			datepicker.setDateComparisons(datepicker);
		}
	};

	const addDatepickerOptionsFilter = () => {
		if (typeof gform === "undefined" || typeof gform.addFilter !== "function") {
			return false;
		}

		gform.addFilter(
			"gform_datepicker_options_pre_init",
			(options, formId, fieldId) => {
				// Open the calendar on focus, so the calendar button is not the
				// only discoverable way to fill a date field.
				options.openOnFocus = true;

				const inquiryFormId = parseInt(formId, 10);
				const inquiryFieldId = parseInt(fieldId, 10);
				if (!INQUIRY_FORM_IDS.includes(inquiryFormId)) {
					return options;
				}

				// Check-in can be today at the earliest.
				if (inquiryFieldId === CHECK_IN_FIELD_ID) {
					options.minDate = getToday();

					return options;
				}

				if (inquiryFieldId !== CHECK_OUT_FIELD_ID) {
					return options;
				}

				options.minDate = getCheckOutMinDate(inquiryFormId);

				// Runs once per open, so it picks up a check-in date that was
				// chosen after this picker was built.
				options.configure = function (datepicker) {
					try {
						applyCheckOutMinDate(datepicker, inquiryFormId);
					} catch (error) {
						// Leave the range alone; enforceCheckOutDate still guards it.
					}

					return true; // Re-render with the refreshed range.
				};

				return options;
			},
			10,
			"agaveVillasDatepickerOptions",
		);

		return true;
	};

	const syncInquiryDateFields = () => {
		INQUIRY_FORM_IDS.forEach(enforceCheckOutDate);
	};

	// Delegated so the handler survives Gravity Forms' AJAX re-renders.
	document.addEventListener("change", (event) => {
		const fieldMatch =
			event.target && event.target.id
				? event.target.id.match(/^input_(\d+)_(\d+)$/)
				: null;
		if (!fieldMatch) return;

		const formId = parseInt(fieldMatch[1], 10);
		const fieldId = parseInt(fieldMatch[2], 10);
		if (
			!INQUIRY_FORM_IDS.includes(formId) ||
			(fieldId !== CHECK_IN_FIELD_ID && fieldId !== CHECK_OUT_FIELD_ID)
		) {
			return;
		}

		enforceCheckOutDate(formId);
	});

	if (!addDatepickerOptionsFilter()) {
		document.addEventListener(
			"gform_main_scripts_loaded",
			addDatepickerOptionsFilter,
			{ once: true },
		);
	}

	// Gravity Forms builds each picker lazily, on the input's first focus, so
	// that first focus happens too early for `openOnFocus` to act on it. Setting
	// the same flag Gravity Forms' calendar button uses makes it open the
	// calendar as soon as the build finishes. Capture phase, so it runs before
	// Gravity Forms' own focusin handler starts the build.
	document.addEventListener(
		"focusin",
		(event) => {
			const inputEl = event.target;
			if (
				inputEl instanceof HTMLInputElement &&
				inputEl.classList.contains("gform-datepicker") &&
				!inputEl.dataset.initialized
			) {
				inputEl.dataset.toggleClickedBeforeInit = "true";
			}
		},
		true,
	);

	syncInquiryDateFields();

	// Gravity Forms replaces the form markup after an AJAX submission.
	if (typeof jQuery === "function") {
		jQuery(document).on("gform_post_render", syncInquiryDateFields);
	}

	// Villa intro read-more toggle (single property pages only).
	(function setupVillaIntroToggle() {
		const intro = document.querySelector(".js-villa-intro");
		const toggle = document.querySelector(".js-villa-intro-toggle");

		if (!intro || !toggle) {
			return;
		}

		const collapsedClass = "is-collapsed";
		const expandedClass = "is-expanded";
		const readMoreLabel = toggle.dataset.readMore || "Read More";
		const readLessLabel = toggle.dataset.readLess || "Read Less";
		const collapsedHeight = 320;

		const setExpandedHeight = function () {
			intro.style.setProperty(
				"--villa-intro-expanded-height",
				`${intro.scrollHeight}px`,
			);
		};

		const setCollapsed = function () {
			intro.classList.add(collapsedClass);
			intro.classList.remove(expandedClass);
			toggle.textContent = readMoreLabel;
			toggle.setAttribute("aria-expanded", "false");
		};

		const setExpanded = function () {
			setExpandedHeight();
			intro.classList.remove(collapsedClass);
			intro.classList.add(expandedClass);
			toggle.textContent = readLessLabel;
			toggle.setAttribute("aria-expanded", "true");
		};

		const refresh = function () {
			setExpandedHeight();
			setCollapsed();

			const hasOverflow = intro.scrollHeight > collapsedHeight + 4;
			toggle.hidden = !hasOverflow;

			if (!hasOverflow) {
				intro.classList.remove(collapsedClass, expandedClass);
				intro.style.removeProperty("--villa-intro-expanded-height");
			}
		};

		toggle.addEventListener("click", function () {
			if (intro.classList.contains(collapsedClass)) {
				setExpanded();
				return;
			}

			setCollapsed();
		});

		refresh();
		window.addEventListener("resize", refresh);
	})();
});
// END Vanilla JS

// jQuery-specifc code
jQuery(function ($) {
	// Menu Dropdowns
	var svgOpen =
		'<div class="dropdown-trigger position-absolute end-0 translate-middle-y text-center lh-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="none" stroke="#ffffff" stroke-width="12" stroke-linecap="round" stroke-linejoin="round" d="M128 192l128 128 128-128"/></svg></div>';
	$("#main-nav .menu-item.dropdown").each(function () {
		// Appends the dropdown arrow
		$(this).append(svgOpen);
	});
	$("#main-nav .menu-item .dropdown-trigger").click(function () {
		// Toggles the dropdown
		$(this).siblings(".dropdown-menu").toggleClass("show");
	});
	// If #main-nav a.menu-item link is "#", open the dropdown instead of going to "#"
	$("#main-nav .menu-item a.nav-link").click(function (e) {
		if ($(this).attr("href") === "#") {
			e.preventDefault();
			$(this).siblings(".dropdown-menu").toggleClass("show");
		}
	});

	//
	// Villa Header Slider
	//
	$(".villa-header-slider").each(function () {
		const $slider = $(this);

		// Function to load slide image for header
		const loadSlideImage = (swiper, index) => {
			const slide = swiper.slides[index];
			if (!slide || slide.dataset.loaded) return;

			const url = slide.dataset.url;
			const alt = slide.dataset.alt;
			if (!url) return;

			const imageEl = document.createElement("img");
			imageEl.src = url;
			imageEl.alt = alt || "";
			imageEl.classList.add("w-100", "h-100");
			imageEl.style.cssText = "object-fit:cover; object-position:center;";

			slide.appendChild(imageEl);
			slide.dataset.loaded = "true";
		};

		const swiper = new Swiper(this, {
			effect: "fade",
			fadeEffect: { crossFade: true },
			modules: [Autoplay, EffectFade, Navigation, Keyboard],
			navigation: {
				nextEl: $slider.find(".swiper-button-next")[0],
				prevEl: $slider.find(".swiper-button-prev")[0],
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			loop: true,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			speed: 1000,
			on: {
				init(swiper) {
					// Load initial slide
					loadSlideImage(swiper, swiper.activeIndex);
				},
				slideChange(swiper) {
					// Preload current + neighbors
					[
						swiper.activeIndex,
						(swiper.activeIndex + 1) % swiper.slides.length,
						(swiper.activeIndex - 1 + swiper.slides.length) %
							swiper.slides.length,
					].forEach((i) => {
						loadSlideImage(swiper, i);
					});
				},
			},
		});

		// Store instance for syncing with modal
		$slider.data("swiper", swiper);

		// Ensure proper sizing after images load
		imagesLoaded($slider[0], function () {
			swiper.update();
		});
	});

	// Fullscreen Gallery Modal (Swiper + Thumbs)
	const $galleryModal = $("#fullscreenModal");
	if ($galleryModal.length) {
		$galleryModal.on("shown.bs.modal", function () {
			const $modal = $(this);
			if ($modal.data("modal-swipers")) {
				// Already initialized; just update sizes
				const { main, thumbs } = $modal.data("modal-swipers");
				main.update();
				thumbs.update();
				return;
			}

			const thumbsEl = $modal.find(".villa-modal-thumbs")[0];
			const mainEl = $modal.find(".villa-modal-slider")[0];
			if (!thumbsEl || !mainEl) return;

			// Function to load slide image
			const loadSlideImage = (swiper, index) => {
				const slide = swiper.slides[index];
				if (!slide || slide.dataset.loaded) return;

				const url = slide.dataset.url;
				const alt = slide.dataset.alt;
				if (!url) return;

				const imageEl = document.createElement("img");
				imageEl.src = url;
				imageEl.alt = alt || "";
				imageEl.style.cssText = "max-height:80vh; object-fit:contain;";
				imageEl.classList.add("w-auto");

				slide.appendChild(imageEl);
				slide.dataset.loaded = "true";
			};

			const thumbsSwiper = new Swiper(thumbsEl, {
				modules: [FreeMode],
				slidesPerView: 6,
				spaceBetween: 8,
				freeMode: true,
				watchSlidesProgress: true,
				slideToClickedSlide: true,
				breakpoints: {
					0: { slidesPerView: 4 },
					768: { slidesPerView: 6 },
					1200: { slidesPerView: 8 },
				},
			});

			const mainSwiper = new Swiper(mainEl, {
				modules: [Navigation, Keyboard, Thumbs, EffectFade],
				loop: true,
				speed: 500,
				effect: "fade",
				fadeEffect: { crossFade: true },
				centeredSlides: true,
				keyboard: { enabled: true, onlyInViewport: false },
				navigation: {
					nextEl: $modal.find(".swiper-button-next")[0],
					prevEl: $modal.find(".swiper-button-prev")[0],
				},
				thumbs: { swiper: thumbsSwiper },
				on: {
					init(swiper) {
						// Load initial slide
						loadSlideImage(swiper, swiper.activeIndex);
					},
					slideChange(swiper) {
						// Preload current + neighbors
						[
							swiper.activeIndex,
							(swiper.activeIndex + 1) % swiper.slides.length,
							(swiper.activeIndex - 1 + swiper.slides.length) %
								swiper.slides.length,
						].forEach((i) => {
							loadSlideImage(swiper, i);
						});
					},
				},
			});

			// Sync starting slide with header slider if available
			const headerSwiper = $(".villa-header-slider").data("swiper");
			if (headerSwiper && typeof headerSwiper.realIndex === "number") {
				mainSwiper.slideToLoop(headerSwiper.realIndex, 0, false);
				thumbsSwiper.slideTo(headerSwiper.realIndex, 0, false);
			}

			// Ensure correct layout once images are loaded
			imagesLoaded($modal[0], function () {
				mainSwiper.update();
				thumbsSwiper.update();
			});

			$modal.data("modal-swipers", { main: mainSwiper, thumbs: thumbsSwiper });
		});

		$galleryModal.on("hidden.bs.modal", function () {
			const $modal = $(this);
			const swipers = $modal.data("modal-swipers");
			if (swipers) {
				try {
					swipers.main.destroy(true, false);
				} catch (e) {}
				try {
					swipers.thumbs.destroy(true, false);
				} catch (e) {}
				$modal.removeData("modal-swipers");
			}
		});
	}

	// Scrollspy classes
	$(".slide-in-bottom-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-medium; delay: 100",
	);
	$(".slide-in-right-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-medium; delay: 100",
	);
	$(".slide-in-bottom-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-left-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-small; delay: 100",
	);
	$(".slide-in-right-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-small; delay: 100",
	);
	$(".fade-in").attr("uk-scrollspy", "cls: uk-animation-fade; delay: 100");
	$(".fade-in-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-fade; delay: 100",
	);
	$(".slide-in-bottom-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-bottom-md-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-left-small; delay: 100",
	);

	// Testimonials Block Slider
	if ($(".swiper-testimonials").length) {
		$(".swiper-testimonials").each(function () {
			new Swiper(this, {
				direction: "horizontal",
				autoHeight: true,
				loop: true,
				speed: 500,
				slidesPerView: 1,
				effect: "fade",
				modules: [Navigation, EffectFade],
				fadeEffect: {
					crossFade: true,
				},
				navigation: {
					nextEl: $(this).find(".swiper-button-next")[0],
					prevEl: $(this).find(".swiper-button-prev")[0],
				},
			});
		});
	}

	// Find each .villa-carousel-swiper and initiate Swiper
	if ($(".villa-carousel-swiper").length) {
		$(".villa-carousel-swiper").each(function () {
			const swiper = new Swiper(this, {
				loop: true,
				speed: 600,
				slidesPerView: 3,
				spaceBetween: 16,
				modules: [Navigation, Keyboard],
				navigation: {
					nextEl: $(this).find(".swiper-button-next")[0],
					prevEl: $(this).find(".swiper-button-prev")[0],
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					768: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
				},
			});

			// Ensure proper sizing after images load
			imagesLoaded($(this)[0], function () {
				swiper.update();
			});
		});
	}

	// toTopButton
	if ($("#toTopButton").length) {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 600) {
				$("#toTopButton").removeClass("hidden");
			} else {
				$("#toTopButton").addClass("hidden");
			}
		});
		// Smoothly scroll back to top when the button is clicked
		$("#toTopButton").on("click", function (event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}

	// Blog Category Filter
	const categoryFilter = document.getElementById("category-filter");
	if (categoryFilter) {
		const categoryButtons = categoryFilter.querySelectorAll(".category-btn");
		const blogPostsContainer = document.getElementById("blog-posts");
		const blogContainer = document.getElementById("blog");
		const postsPerPage =
			parseInt(blogContainer?.getAttribute("data-posts-per-page")) || 9;
		let currentCategory = "all";
		let currentPage = 1;
		let currentSearch = "";

		// Set "All" button as active initially
		categoryButtons.forEach((btn) => {
			if (btn.getAttribute("data-category") === "all") {
				btn.classList.add("active");
			} else {
				btn.classList.remove("active");
			}
		});

		const loadPosts = (category, page = 1, search = "") => {
			// Scroll to blog section first with -100px offset
			const blogElement = document.getElementById("blog");
			if (blogElement) {
				const elementPosition =
					blogElement.getBoundingClientRect().top + window.pageYOffset;
				const offsetPosition = elementPosition - 100; // 100px offset from top
				window.scrollTo({
					top: offsetPosition,
					behavior: "smooth",
				});
			}

			const formData = new FormData();
			formData.append("action", "filter_blog_posts");
			formData.append("category", category);
			formData.append("paged", page);
			formData.append("posts_per_page", postsPerPage);
			formData.append("search", search);

			// Show loading
			blogPostsContainer.innerHTML = `
				<div class="text-center py-5">
					<div class="spinner-grow text-primary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
					<div>Loading Tips...</div>
				</div>
			`;

			fetch(ajax_object.ajax_url, {
				method: "POST",
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.success) {
						blogPostsContainer.innerHTML = data.data.content;
						currentCategory = category;
						currentPage = page;
						currentSearch = search;
					}
				})
				.catch((error) => {
					console.error("Error loading posts:", error);
					blogPostsContainer.innerHTML =
						'<div class="text-center py-5 text-danger">Error loading posts. Please try again.</div>';
				});
		};

		categoryButtons.forEach((button) => {
			button.addEventListener("click", function (e) {
				e.preventDefault();

				// Update active button
				categoryButtons.forEach((btn) => btn.classList.remove("active"));
				this.classList.add("active");

				const category = this.getAttribute("data-category");
				loadPosts(category, 1, currentSearch);
			});
		});

		// Handle pagination clicks
		document.addEventListener("click", function (e) {
			if (e.target.closest(".pagination a")) {
				e.preventDefault();
				const link = e.target.closest(".pagination a");
				const url = new URL(link.href);

				// Extract page number from URL path (WordPress pagination format: /page/2/)
				let page = 1;
				const pathMatch = url.pathname.match(/\/page\/(\d+)\//);
				if (pathMatch) {
					page = parseInt(pathMatch[1]);
				} else {
					// Fallback to query parameter
					page = parseInt(url.searchParams.get("paged")) || 1;
				}

				loadPosts(currentCategory, page, currentSearch);
			}
		});

		// Handle search
		const searchInput = document.getElementById("blog-search");
		const searchBtn = document.getElementById("search-btn");
		if (searchBtn && searchInput) {
			const performSearch = () => {
				const searchTerm = searchInput.value.trim();
				loadPosts(currentCategory, 1, searchTerm);
			};
			searchBtn.addEventListener("click", performSearch);
			searchInput.addEventListener("keypress", (e) => {
				if (e.key === "Enter") {
					performSearch();
				}
			});
		}
	}
});
